exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".index__cardImg___1qswZ {\n  height: 285px;\n  width: 100%;\n  object-fit: contain;\n  background-color: #efefef;\n}\n", "",{"version":3,"sources":["index.less"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B","file":"index.less","sourcesContent":[".cardImg {\n  height: 285px;\n  width: 100%;\n  object-fit: contain;\n  background-color: #efefef;\n}\n"]}]);

// Exports
exports.locals = {
	"cardImg": "index__cardImg___1qswZ"
};